export const SITE = {
  brand: "MarX Plumbing",
  shortBrand: "MarX",
  phone: "0414 147 200",
  phoneHref: "tel:+61414147200",
  email: "marxplumbingservices@gmail.com",
  emailHref: "mailto:marxplumbingservices@gmail.com",
  instagram: "https://www.instagram.com/marxplumbing_/",
  instagramHandle: "@marxplumbing_",
  facebook: "https://www.facebook.com/search/top?q=marx%20plumbing",
  facebookHandle: "MarX Plumbing",
  suburb: "Concord",
  region: "Sydney Inner West",
  state: "NSW",
  country: "Australia",
  license: "NSW Lic. 472396C",
  established: "Est. 2023",
  hours: [
    { day: "Mon — Fri", time: "24/7" },
    { day: "Saturday", time: "24/7" },
    { day: "Sunday", time: "24/7" },
  ],
  serviceAreas: [
    "Concord",
    "Five Dock",
    "Drummoyne",
    "Haberfield",
    "Leichhardt",
    "Rozelle",
    "Balmain",
    "Lilyfield",
    "Russell Lea",
    "Abbotsford",
    "Canada Bay & Surrounds",
    "Burwood",
    "Strathfield",
    "Homebush",
    "Rhodes",
    "Breakfast Point",
    "Mortlake",
    "Eastern Suburbs",
    "Paddington",
    "Woollahra",
    "Bondi",
    "Bondi Junction",
    "Double Bay",
    "Vaucluse",
    "Bellevue Hill",
    "Northern Beaches",
    "Manly",
    "Balgowlah",
    "Freshwater",
    "Curl Curl",
    "Mosman",
    "Hunters Hill",
  ],
  logo: "/assets/marx-logo.png?v=3",
};

export const SERVICES = [
  {
    id: "renovations",
    no: "01",
    title: "High-End Renovations",
    desc: "From luxury bathrooms and designer kitchens to complete home transformations, we provide expert plumbing services tailored to the highest standards of quality and workmanship.",
    image:
      "https://images.unsplash.com/photo-1625801882109-032ad88edeb3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    size: "wide",
  },
  {
    id: "custom-homes",
    no: "02",
    title: "Custom Homes",
    desc: "From initial groundworks through to final fit-off, we deliver complete plumbing solutions for custom homes, including drainage, stormwater, gas, hot and cold water services, fixture installation and compliance certification.",
    image:
      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    size: "tall",
  },
  {
    id: "commercial",
    no: "03",
    title: "Maintenance",
    desc: "Scheduled care for family homes, real estate, restaurants, salons, offices and strata. Priority response, after-hours servicing and detailed reporting on every visit.",
    image:
      "https://images.pexels.com/photos/3721272/pexels-photo-3721272.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    size: "square",
  },
  {
    id: "remodels",
    no: "04",
    title: "Bathroom & Kitchen Remodels",
    desc: "We partner with your designer or ours — managing fixtures, finishes, and the trades that make luxury rooms feel effortless.",
    image:
      "https://images.unsplash.com/photo-1609210884848-2d530cfb2a07?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    size: "square",
  },
  {
    id: "hot-water",
    no: "05",
    title: "Water Heater Install & Repair",
    desc: "Continuous-flow gas, heat-pump and solar systems. Same-day repairs and like-for-like emergency replacements across Sydney.",
    image: "/assets/water-heater.jpg?v=5",
    size: "wide",
  },
  {
    id: "drain-leak",
    no: "06",
    title: "Drain Cleaning & Leak Detection",
    desc: "CCTV camera inspection, thermal leak detection, jet-rodding and tree-root clearing — no guesswork, no unnecessary demolition.",
    image: "/assets/drain-leak.jpg?v=1",
    size: "tall",
  },
  {
    id: "luxury",
    no: "07",
    title: "Luxury Fixtures & Custom Installations",
    desc: "Reece, Cass Brothers, ABI Interiors, Caroma, Phoenix — we work with the suppliers your interior designer trusts, and we install to spec.",
    image:
      "https://images.unsplash.com/photo-1629078692818-c5a0443f4ae3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    size: "wide",
  },
];

export const PROCESS_STEPS = [
  {
    no: "01",
    title: "Discovery Call",
    body: "We listen first. Understanding your plans, priorities and expectations allows us to provide clear advice, accurate pricing and a smooth project from start to finish.",
  },
  {
    no: "02",
    title: "On-Site Survey",
    body: "We attend the property, measure, photograph and review existing services with you in person.",
  },
  {
    no: "03",
    title: "Detailed Proposal",
    body: "A clear and comprehensive proposal outlining the scope of works, inclusions, exclusions, allowances and project timeline, so you know exactly what to expect from the outset.",
  },
  {
    no: "04",
    title: "Quality Installation",
    body: "Our team delivers high-quality plumbing installations, maintains a tidy worksite and keeps you informed from start to finish.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Outstanding service from Marc and his boys at MarX Plumbing. Friendly, professional, and top-quality workmanship. It's clear they take pride in their work — highly recommend to anyone needing a plumber.",
    author: "Carmel Payne",
    role: "Sydney",
  },
  {
    quote:
      "We had Marc from MarX Plumbing do a septic tank changeover and couldn't be happier. Marc was reliable, easy to deal with, and clearly knew his stuff. Everything was handled smoothly from start to finish. Great service and workmanship — would definitely recommend!",
    author: "Chontelle Marsh",
    role: "Sydney",
  },
  {
    quote:
      "I had an emergency issue with a burst pipe. The MarX Plumbing crew were there to fix it on that day. They were professional, on time, had exceptional service and fixed my issue on that day with no fuss. Highly recommend Marc and his crew. Thank you once again.",
    author: "Mustafa Orcun",
    role: "Sydney",
  },
  {
    quote:
      "Marc did an excellent job with the plumbing and installation of fixtures for our bathroom renovation. Went the extra mile and kept everything clean.",
    author: "Callan Avery",
    role: "Sydney",
  },
  {
    quote:
      "Marc came out and fixed the tap in our bathroom as well as the drain. He was professional, punctual, and communicated clearly throughout the entire process. The work was completed efficiently and to a high standard. We were very happy with the service and would highly recommend him.",
    author: "Emily Krysztoforski",
    role: "Sydney",
  },
  {
    quote:
      "Had Marc come install a dishwasher. Had to run new waste and water because it's on the other side of the kitchen. Installed the water outlet and waste in the pantry cupboard and can't even tell it's there — neat and tidy work. Great pricing and communication.",
    author: "Michael Midson",
    role: "Sydney",
  },
  {
    quote:
      "I am pleased that the noise from the water hammer has been resolved. Thank you for your efforts in helping to resolve the issue in my house. It is greatly appreciated.",
    author: "Kelvin Chua",
    role: "Sydney",
  },
  {
    quote: "Best work, great communication — highly recommend.",
    author: "Jake Assange",
    role: "Sydney",
  },
];

export const PORTFOLIO = [
  {
    title: "Waverley Master Ensuite",
    tag: "Renovation",
    url: "/assets/waverley.jpg?v=2",
  },
  {
    title: "Drummoyne Kitchen",
    tag: "Custom Home",
    url: "https://images.unsplash.com/photo-1629078692818-c5a0443f4ae3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    title: "Strathfield Powder Room",
    tag: "Luxury Fixtures",
    url: "/assets/strathfield.jpg",
  },
  {
    title: "Five Dock Family Bath",
    tag: "Remodel",
    url: "/assets/fivedock.jpg",
  },
  {
    title: "Hunters Hill Heritage",
    tag: "Renovation",
    url: "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    title: "Saint Johns College",
    tag: "Commercial",
    url: "/assets/stjohns.jpg",
  },
];
